const GIFT_AID_FIELDS = ['address1', 'address2', 'city', 'zip', 'country'];

export function isGiftAidField(field) {
    return GIFT_AID_FIELDS.includes(field);
}
